import React, { Component } from 'react';
import { Col, Row, FormGroup, Radio } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  savePTRequirementsInfo,
  updatePTRequirementsInfo
} from '../actions';
import PTRequirementsValidation from '../validation/ptRequirementsValidation';

import FormSectionStatus from './FormSectionStatus';

class PTRequirements extends Component {
  constructor(props){
    super(props);
    this.saveAndContinue = this.saveAndContinue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleHSorGEDChange = this.handleHSorGEDChange.bind(this);
    this.handleVeteranChange = this.handleVeteranChange.bind(this);
    this.handleTransferChange = this.handleTransferChange.bind(this);
    PTRequirements.getValidationState = PTRequirements.getValidationState.bind(this);
  }

  handleChange(e) {
    const {dispatch} = this.props;
    let updates = {};
    updates[e.target.name] = e.target.value;
    dispatch(updatePTRequirementsInfo(updates));
  }

  handleHSorGEDChange(e) {
    const { dispatch } = this.props;
    let updates = {
      hsOrGED: (e.target.value === 'Y')
    };
    dispatch(updatePTRequirementsInfo(updates));
  }

  handleVeteranChange(e) {
    const { dispatch } = this.props;
    let updates = {
      veteran: (e.target.value === 'Y')
    };
    dispatch(updatePTRequirementsInfo(updates));
  }

  handleTransferChange(e) {
    const { dispatch } = this.props;
    let updates = {
      transferOption: (e.target.value === 'Y')
    };
    dispatch(updatePTRequirementsInfo(updates));
  }

  saveAndContinue(e){
    e.preventDefault();
    if(PTRequirements.getValidationState() === 'success') {
      console.log('Update Database');
      this.props.dispatch(savePTRequirementsInfo(this.props.educationInfo));
    } else {
      console.log('Not Saved');
    }
  }

  static getValidationState(){
    return 'success';
  }

  render() {
    const { transferOption, veteran, hsOrGED } = this.props;
    const validationStatus = new PTRequirementsValidation().getValidationStatus(this.props);
    const space = ' ';

    return (
      <div>
        <h2>Psychiatric Technician Requirements</h2>
        <Row>
          <Col sm={12}>
            <h4>Secondary Education</h4>
            <p>
              The PT program requires that applicants be at least 18 years of age and have completed 12th grade either by graduating
              from high school or earning an equivalent education (e.g. GED).
            </p>
            <p>
              Are you at least 18 years of age AND have completed 12th grade with official high school records or an equivalent (e.g. GED)?
            </p>
            <FormGroup
              controlId={'hs-or-ged'}
            >
              <Radio
                name={'hs-or-ged'}
                inline
                onChange={this.handleHSorGEDChange}
                value="Y"
                checked={hsOrGED}
              >
                Yes
              </Radio>
              {space}
              <Radio
                name={'hs-or-ged'}
                inline
                onChange={this.handleHSorGEDChange}
                value="N"
                checked={!hsOrGED}
              >
                No
              </Radio>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <h4>Veteran Status</h4>
            <p>
              Presently, we have spaces reserved for veterans with honorable discharges who meet minimum program requirements.
            </p>
            <p>
              Are you a veteran?
            </p>
            <FormGroup
              controlId={'veteran-status'}
            >
              <Radio
                name={'veteran-status'}
                inline
                onChange={this.handleVeteranChange}
                value="Y"
                checked={veteran}
              >
                Yes
              </Radio>
              {space}
              <Radio
                name={'veteran-status'}
                inline
                onChange={this.handleVeteranChange}
                value="N"
                checked={!veteran}
              >
                No
              </Radio>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <h4>Previous Experience</h4>
            <p>
              PT applicants who have completed the Vocational Nursing or Psychiatric Technician program (fully or partially)
              are eligible to apply to the PT program as a TRANSFER.
              Applicants may apply for this option only if they were in GOOD STANDING with the program. (Current PT/VN Licenses are not required).<br/>
              For additional information, see the {space}
              <a href="https://www.deltacollege.edu/academics/academic-divisions/health-sciences-division/psychiatric-technician/psychiatric-technician" target="_blank">Psychiatric Technician FAQs</a>
            </p>
            <p>
              Would you like to apply as a transfer (if eligible)?
            </p>
            <FormGroup
              controlId={'transfer-option'}
            >
              <Radio
                name={'transfer-option'}
                inline
                onChange={this.handleTransferChange}
                value="Y"
                checked={transferOption}
              >
                Yes
              </Radio>
              {space}
              <Radio
                name={'transfer-option'}
                inline
                onChange={this.handleTransferChange}
                value="N"
                checked={!transferOption}
              >
                No
              </Radio>
            </FormGroup>
          </Col>
        </Row>
        <FormSectionStatus {...validationStatus.section}/>
      </div>
    );
  };
}

export default connect(
  (state) => {
    const { ptRequirementsInfo } = state;
    return { ...ptRequirementsInfo };
  }
)(PTRequirements);